// extracted by mini-css-extract-plugin
export default {"name":"ParticipantStreamComponent_name__yU3KY","videoComp":"ParticipantStreamComponent_videoComp__UmbBY"};